<template>
    <div :class="wrapclass+ '-wrap'" v-if="info">
        <div :class="{'author-mod':true,'new-name-jhty':newNameJhty}" v-if="info.user_info">
            <div class="author-face">
                <div class="user-face">
                    <img :src="changeUserImgUrls(info.user_info && info.user_info.avatar)" class="user-face" />
                </div>
                <i class="level" v-if="info.user_info.mp_rank * 1 > 0">
                    <img :src="authorlevelurl + info.user_info.mp_rank + '.png'" />
                </i>
                <i class="level" v-else-if="info.user_info.anchor_status == 1">
                    <img :src="anchorurl" />
                </i>
            </div>
            <div class="author-desc">
                <div class="author">
                    <span v-if="info.user_info && info.user_info.nickname" :class="{'name':true,'new-name-jhty':newNameJhty}">{{info.user_info.nickname}}</span>
                    <span v-if="info.user_info.level === '1'" class="honour"><img src="https://s.jihaimall.com/h5/image/v.png" /></span>
                    <span v-if="info.severalWin" class="feats"><i>{{info.severalWin}}</i></span>
                    <span v-if="info.seriesMiss" class="even black"><b class="num">{{info.seriesMiss.replace("连黑", "") || 0}}</b></span>
                    <span v-if="info.seriesWin" class="even red"><b class="num">{{info.seriesWin.replace("连红", "") || 0}}</b></span>
                </div>
                <div class="exploits">
                    <span v-if="info.good_at_league" :class="'hit ' + hitStyle(info) + ''">{{info.good_at_league}}</span>
                    <span v-if="info.good_at_play"   :class="'hit ' + hitStyle(info) + ''">{{info.good_at_play}}</span>
                    <span v-if="(info.good_at_league == '' || info.good_at_play == '') && info.ten_win_club"   :class="'hit ' + hitStyle(info) + ''">{{info.ten_win_club}}</span>
                </div>
                <div class="about" v-if="info.user_info && info.user_info.nickname">{{info.user_info.intro}}</div>
            </div>
            <div :class="{'author-follow': true,'icon': true,'i_unfollow': !is_followed,'followed': is_followed,none: !show_follow || isBaiduBoxs()}">
            </div>
        </div>
        <div class="article-mod">
            <div :class="{'article-match-bg':true,'new-name-jhty':newNameJhty}"></div>
            <div class="article-container">
                <div class="article-view">
                    <div :class="{'match-mod': true,'none': !info.match_info,'new-name-jhty':newNameJhty}">
                        <div class="match-layout">
                            <div class="match-head">
                                <div class="match-col-1">{{info.match_info.leagueNameJ}} {{info.jc == 1 ? "竞彩" : ""}}{{info.match_info.jcId}}</div>
                                <div v-if="!isBaiduBoxs()" class="match-col-2"><span :class="{'follow-match': true}" >{{is_followed_match == 1 ? "取消关注" : "点击关注"}}</span></div>
                                <div v-else-if="info.type === '27'" class="match-col-2"><span :class="{'follow-match': true}">查看比分</span></div>
                                <div class="match-col-3"><div class="none" id="match_countdown">距截止 <em id="countdown_hh">00</em> : <em id="countdown_mm">00</em> : <em id="countdown_ss">00</em></div></div>
                            </div>
                            <div class="match-team">
                                <template v-if="bkb_away == 1 && (info.type == '11' || info.type == '12' || info.type == '6')">
                                    <div class="match-col">
                                        <div class="team-logo"><img :src="matchLogo(info,'away')" /></div>
                                        <div class="team-name"><span class="team-tips">[客]</span>{{info.match_info.awayNameJ}}</div>
                                    </div>
                                    <div class="match-col">
                                    <div class="match-time">{{matchTime}}</div>
                                    <div :class="{'match-vs':true,'dj-match-vs':info.type === '27' && info.matchState !== '0', 'djing': info.matchState === '1'}">{{matchVs}}</div>
                                    <div class="match-live">
                                        <span class="video" v-if="info.match_info.tvFlag == 1">视频直播</span>
                                        <span class="animate" v-if="info.match_info.animation == 1">动画直播</span>
                                    </div>
                                    </div>
                                     <div class="match-col">
                                        <div class="team-logo"><img :src="matchLogo(info,'home')" /></div>
                                        <div class="team-name">{{info.match_info.homeNameJ}}</div><span class="team-tips tip-top">[主]</span>
                                    </div>
                                    <template v-if="info.matchid">
                                        <template v-if="info.type === '9' || info.type == '11'">
                                                <div v-if="info.isWin == 1" :class="newsTxtAdjust ? 'match-result red2' : 'match-result red'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 2" :class="newsTxtAdjust ? 'match-result black2' : 'match-result black'" id="match_hit"></div>
                                        </template>
                                        <template v-else>
                                                <div v-if="info.isWin == 1" :class="newsTxtAdjust ? 'match-result hit2' : 'match-result hit'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 2" :class="newsTxtAdjust ? 'match-result not2' : 'match-result not'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 3" :class="newsTxtAdjust ? 'match-result run2' : 'match-result run'" id="match_hit"></div>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="match-col">
                                        <div class="team-logo"><img :src="matchLogo(info,'home')" /></div>
                                        <div class="team-name"><span class="team-tips">[主]</span>
                                        <template v-if="info.type == '11' || info.type == '12' || info.type == '6' || info.type == '27'">
                                                <span class="team-tips">[主]</span>
                                        </template>
                                        {{info.match_info.homeNameJ}}</div>
                                    </div>
                                    <div class="match-col">
                                        <div class="match-time">{{matchTime}}</div>
                                        <div :class="{'match-vs':true,'dj-match-vs':info.type === '27' && info.matchState !== '0', 'djing': info.matchState === '1'}">{{matchVs}}</div>
                                        <div class="match-live">
                                            <span class="video" v-if="info.match_info.tvFlag == 1">视频直播</span>
                                            <span class="animate" v-if="info.match_info.animation == 1">动画直播</span>
                                        </div>
                                    </div>
                                    <div class="match-col">
                                        <div class="team-logo"><img :src="matchLogo(info,'away')" /></div>
                                        <div class="team-name name-fl-left">{{info.match_info.awayNameJ}}</div><span class="team-tips tip-top">[客]
                                            <template v-if="info.type == '11' || info.type == '12' || info.type == '6' || info.type == '27'">
                                                <span class="team-tips tip-top">[客]</span>
                                            </template>
                                        </span>
                                    </div>
                                    <template v-if="info.matchid">
                                        <template v-if="info.type == '9' || info.type == '11'">
                                                <div v-if="info.isWin == 1" :class="newsTxtAdjust ? 'match-result red2' : 'match-result red'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 2" :class="newsTxtAdjust ? 'match-result black2' : 'match-result black'" id="match_hit"></div>
                                        </template>
                                        <template v-else>
                                                <div v-if="info.isWin == 1" :class="newsTxtAdjust ? 'match-result hit2' : 'match-result hit'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 2" :class="newsTxtAdjust ? 'match-result not2' : 'match-result not'" id="match_hit"></div>
                                                <div v-else-if="info.isWin == 3" :class="newsTxtAdjust ? 'match-result run2' : 'match-result run'" id="match_hit"></div>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <template v-if="info.free == '2' && !info.feetext">
                            <payinfo :info="info"/>
                        </template>
                        <template v-if="info.matchState">
                            <template v-if="info.free == '2' && !info.feetext && info.matchState != '0'">
                                <template v-if="info.matchState * 1 > 0">
                                    <div class="match-pay disabled">
                                        <span class="need-disabled">赛事已开赛,无法付费查看</span>
                                    </div>
                                </template>
                                <template v-else-if="info.matchState * 1 < 0">
                                    <template v-if="info.end_open == 0">
                                        <div v-if="info.type == 2" class="match-pay disabled">
                                            <span class="need-disabled">赛事{{zqMatchStateMap[info.matchState] || "已结束"}},无法付费查看</span>
                                        </div>
                                        <div v-else-if="info.type == 12" class="match-pay disabled">
                                            <span class="need-disabled">赛事{{zqMatchStateMap[info.matchState] || "已结束"}},无法付费查看</span>
                                        </div>
                                        <div v-else-if="info.type == 27" class="match-pay disabled">
                                            <span class="need-disabled">赛事{{zqMatchStateMap[info.matchState] || "已结束"}},无法付费查看</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-if="info_type == 27" class="match-pay disabled">
                                            <span class="need-disabled">赛事{{djMatchStateMap[info.matchState] || "已结束"}},无法付费查看</span>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="match-pay disabled">
                                        <span class="need-disabled">赛事已开赛,无法付费查看</span>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-if="info.free == 1 || (info.free == 2 && info.feetext)">
                            <template v-if="info.orders && info.orders.length > 0">
                                <div class="match-bet">
                                    <template v-if="info.type == '11'">
                                        <template  v-if="setInfoOder(info.orders)[0].betCode == '2' || setInfoOder(info.orders)[0].betCode == '1'">
                                            <div class="match-rq rq1">大小分</div>
                                        </template>
                                        <template v-else>
                                            <div class="match-rq rq2">{{setInfoOder(info.orders)[0].odds == "0" ? "胜负" : "让分"}}</div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="match-rq rq1">让球<br/>{{setInfoOder(info.orders)[0].odds > 0 ? "+" + setInfoOder(info.orders)[0].odds : setInfoOder(info.orders)[0].odds}}</div>
                                    </template>
                                    <div class="match-opt">
                                        <ul>
                                            <template v-for="(item,index) in setInfoOder(info.orders)">
                                                <li :key="index" :class="{'selected': item.is_bet * 1,'hited': item.isWin == '1'}">
                                                    <div class="handicap">
                                                        <strong>
                                                            {{item.matchOpts}}
                                                            <cite :class="{'none': !item.oddsFlag, 'up': item.matchShowOdds > 0, 'down': item.matchShowOdds < 0}">{{item.matchShowOdds}}</cite>
                                                        </strong>
                                                    </div>
                                                    <div class="odds">{{item.matchSps}}</div>
                                                    <span class="recommend">推荐</span>
                                                </li>
                                            </template>

                                        </ul>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="info.result">
                                <div class="match-pay finished">
                                    <span class="need-finished">{{info.result}} </span>
                                    <span :class="{'recommend':true,'android':isAndroids()}">推荐</span>
                                </div>
                            </template>
                        </template>
                        <div v-if="info.matchState == -1 && info.isWin * 1 > 0 && info.end_open == 1 && info.free == '2'" class="article-tip">
                            当前付费资讯已公开
                        </div>
                    </div>
                         <p v-if="info.free == '2' && info.need_back == 0" class="fee-noback">该推荐购买后不退还购买金额</p>
                        <template v-if="info.free == '2' && (info.buynews && info.buynews.totalCount * 1)">
                            <div class="fee-mod">
                                <p class="fee-num">{{ (info.buynews && info.buynews.totalCount) || "0"}}
                                    <template v-if="(info.has_back == 2) && info.need_back == 1">
                                        <template v-if="newsTxtAdjust">
                                            人解锁(已退款)
                                        </template>
                                        <template v-else>
                                            人付费(已退款)
                                        </template>
                                    </template>
                                    <template v-else-if="newsTxtAdjust">
                                        人已解锁
                                    </template>
                                    <template v-else>
                                        人已付费
                                    </template>
                                </p>
                                <Userlist :userdata="info.buynews"/>
                            </div>
                        </template>
                    <div class="news-mod">
                        <h1 class="title">{{info.title}}</h1>
                        <div class="sub">
                            <span class="idate">{{info.happened}}</span>
                            <template v-if="info.seal_status * 1 > 0">
                                <img v-if="info.seal_status == '1'" class="report" src="https://s.jihaimall.com/h5/image/article/zhiliangdi@2x.png" />
                                <img v-if="info.seal_status == '2'" class="report" src="https://s.jihaimall.com/h5/image/article/weigui@2x.png" />
                                <img v-if="info.seal_status == '4'" class="report" src="https://s.jihaimall.com/h5/image/article/chaoxi@2x.png" />
                            </template>
                        </div>
                        <Maintext :info="info" :is_owned="is_own"></Maintext>
                    </div>
                        <Card v-if="info.card" :info="info" :is_followed="is_followed" :show_follow="show_follow" :isHiscores="wrapclass" :parent="this"></Card>
                        <template v-if="info.free !='2'">
                            <template v-if="isJHApps() && isJHAppioss() && getAppVs() >= 220">
                                <Reward :info="info"></Reward>
                            </template>
                            <template v-if="isJHApps() && isJHAppAns() && getsrcs().indexOf('JH_037') >= 0 ">
                                <Reward :info="info"></Reward>
                            </template>
                        </template>
                    <div class="writor-mod">友情提示: 文章内容不代表平台观点！关于文章有疑问请联系我们。{{wrapclass == 'hiscores' ? '专家号作者' : '即嗨号'+identity_split}}不会以任何形式私留联系方式加好友或加群，务必谨防诈骗，避免财产损失！</div>
                        <Like :info="info"></Like>
                        <template v-if="info.adlist && info.adlist.length > 0">
                            <div :class="{'ads-mod': true,'nomark': info.adlist[0].is_show != '1'}">
                                <div :class="{'hd':true,'nomark':info.adlist[0].is_show != '1'}">{{info.adlist[0].title}}<span class="ad">广告</span></div>
                                <div class="bd"><img :src="info.adlist[0].imgurl" /></div>
                            </div>
                        </template>
                </div>
                <template v-if="!isBaiduBoxs()">
                    <div v-if="info.myinfolist && info.myinfolist.length > 0">
                        <div class="blank_mod"></div>
                        <div class="recommend-mod">
                            <div class="hd">
                            <span class="line"></span>
                            <span class="teacher"><strong>{{newsTxtAdjust ? "该专家其他分析" : "该专家其他相关推荐"}}</strong></span>
                            </div>
                            <div class="bd author">
                            <ul class="recommend-match">
                                 <li :key="item.id" v-for="(item) in info.myinfolist">
                                    <div class="recommend-match-item">
                                        <p>
                                            <span class="league" :style="{color:item.match_info.Color}">{{item.match_info.leagueNameJ}}</span>
                                            <span class="idate">{{item.match_info.matchTime}}</span>
                                        </p>
                                        <template v-if="bkb_away == 1 && (item.type == '11' || item.type == '12' || item.type == '6')">
                                            <p><span>[客]</span><span class="vs">{{item.match_info.awayNameJ}}  VS  {{item.match_info.homeNameJ}}</span><span>[主]</span></p>
                                        </template>
                                        <template v-else>
                                             <p>
                                                <span v-if="item.type == '11' || item.type == '12' || item.type == '6'">[主]</span>
                                                <span class="vs">{{item.match_info.homeNameJ}}  VS  {{item.match_info.awayNameJ}}</span>
                                                <span v-if="item.type == '11' || item.type == '12' || item.type == '6'">[客]</span>
                                            </p>
                                        </template>
                                        <template v-if="item.free == '1'">
                                            <div class="recommend-free">免费</div>
                                        </template>
                                        <template v-else>
                                            <template v-if="item.need_back == '0'">
                                                <div class="recommend-free nohitnoback">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}</div>
                                            </template>
                                            <template v-else>
                                                <div class="recommend-pay">
                                                    <span class="price">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}</span>
                                                    <template v-if="item.type == '27'">
                                                        <span class="back">{{newsTxtAdjust ? "不红不返" : "不中不返"}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item.need_back != '0'">
                                                            <span class="back">{{newsTxtAdjust ? "不红返还" : "不中返还"}}</span>
                                                        </template>
                                                    </template>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="recommend-match-info">
                                        <template v-if="item.type == '11' || item.type == '12' || item.type == '6'">
                                            <span class="game2">篮球</span>
                                        </template>
                                        <template v-else-if="item.type == '27'">
                                            <span class="game1">电竞</span>
                                        </template>
                                        <template>
                                            <span class="game1">足球</span>
                                        </template>
                                    <span class="idate">{{item.happened}}</span>
                                        <template v-if="item.sales * 1 > 0">
                                            <div class="read">{{item.sales}}{{newsTxtAdjust ? '解锁':'购买'}} {{item.browsenum}}阅读</div>
                                        </template>
                                        <template v-else>
                                            <div class="read">{{item.browsenum}}阅读</div>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="!isBaiduBoxs()">
                    <div v-if="info.matchnews && info.matchnews.length > 0">
                        <div class="blank_mod"></div>
                        <div class="recommend-mod">
                            <div class="hd">
                                <span class="line"></span>
                                <span class="teacher"><strong>{{newsTxtAdjust ? "本场其他分析" : "本场其他相关推荐"}}</strong></span>
                            </div>
                            <div class="bd author">
                                <ul>
                                     <li class="recommend-author-item" v-for="item in info.matchnews" :key="item.id">
                                        <div :class="{'picture':true,'no-good':!item.good_at_league && !item.good_at_play && !item.ten_win_club}">
                                            <img :src="item.user_info.avatar" class="face" />
                                            <template v-if="item.user_info.mp_rank * 1 > 0">
                                                <img :src="authorlevelurl + item.user_info.mp_rank + '.png'" class="level" />
                                            </template>
                                            <template v-else-if="item.user_info.anchor_status == 1">
                                                <img :src="anchorurl" class="level" />
                                            </template>
                                        </div>
                                        <div class="authors">
                                        <p>
                                            <span class="name">{{item.user_info.nickname}} </span>
                                            <span v-if="item.user_info.level == '1'" class="honour"><img src="https://s.jihaimall.com/h5/image/v.png" /></span>
                                        </p>
                                        <p>
                                            <template v-if="info.type == '11' || info.type == '12' || info.type == '6'">
                                                <template v-if="item.good_at_league">
                                                    <span class="tag ball2">{{item.good_at_league}}</span>
                                                </template>
                                                <template v-if="item.good_at_play">
                                                    <span class="tag ball2">{{item.good_at_play}}</span>
                                                </template>
                                                <template v-if="item.good_at_league && !item.good_at_play || item.good_at_play && !item.good_at_league">
                                                    <span v-if="item.ten_win_club" class="tag ball2">{{item.ten_win_club}}</span>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="item.good_at_league">
                                                    <span class="tag ball1">{{item.good_at_league}}</span>
                                                </template>
                                                <template v-if="item.good_at_play">
                                                    <span class="tag ball1">{{item.good_at_play}}</span>
                                                </template>
                                                <template v-if="item.good_at_league && !item.good_at_play || item.good_at_play && !item.good_at_league">
                                                    <span v-if="item.ten_win_club" class="tag ball1">{{item.ten_win_club}}</span>
                                                </template>
                                            </template>
                                        </p>
                                        <p class="percent">
                                            <span v-if="item.isFollowed == '1'" className="other followed">已关注</span>
                                            <span class="other read">{{item.browsenum}}阅读</span>
                                            <template v-if="item.need_back == '1'">
                                                <i className="other return">返</i>
                                                <span className="other price">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}查看</span>
                                            </template>
                                            <template v-else>
                                                <template v-if="item.free == '2'">
                                                    <span className="other price">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}查看</span>
                                                </template>
                                            </template>
                                            <!-- {/* {_play} */} -->
                                        </p>
                                        <div :class="{'rate': true, 'none': item.last_ten_return_rate == '','no-good':!item.good_at_league && !item.good_at_play && !item.ten_win_club}">
                                            <p class="percent"><strong>{{item.last_ten_return_rate.replace(/%/g, "")}}</strong>%</p>
                                            <p>近10场回报率</p>
                                        </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="!isBaiduBoxs()">
                     <div v-if="(info.myinfolist && info.myinfolist.length == 0) && (info.matchnews && info.matchnews.length == 0) && (info.matchhot && info.matchhot.length > 0)">
                        <div className="blank_mod"></div>
                        <div className="recommend-mod">
                            <div className="hd">
                                <span className="line"></span>
                                <span className="teacher"><strong>{{newsTxtAdjust ? "热门分析" : "热门推荐"}}</strong></span>
                            </div>
                            <div className="bd author">
                                <ul className="recommend-match">
                                    <li v-for="item in info.matchhot" :key="item.id" >
                                        <div className="recommend-match-item">
                                            <p><span className="league" :style="{color:item.match_info.Color}">{{item.match_info.leagueNameJ}}</span><span className="idate">{{item.match_info.matchTime}}</span></p>
                                            <template v-if="bkb_away == 1 && (item.type == '11' || item.type == '12' || item.type == '6')">
                                                 <p><span>[客]</span><span className="vs">{item.match_info.awayNameJ}  VS  {item.match_info.homeNameJ}</span><span>[主]</span></p>
                                            </template>
                                            <template>
                                                <p>
                                                    <span v-if="item.type == '11' || item.type == '12' || item.type == '6'">[主]</span>
                                                    <span className="vs">{item.match_info.homeNameJ}  VS  {item.match_info.awayNameJ}</span>
                                                    <span v-if="item.type == '11' || item.type == '12' || item.type == '6'">[客]</span>
                                                </p>
                                            </template>
                                            <template v-if="item.free == '1'">
                                                <div className="recommend-free">免费</div>
                                            </template>
                                            <template v-else>
                                                <template v-if="item.need_back == '0'">
                                                    <div className="recommend-free nohitnoback">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}</div>
                                                </template>
                                                <template>
                                                    <div className="recommend-pay">
                                                        <span className="price">{{item.fee / 100}}{{newsTxtAdjust ? "嗨币" : "元"}}</span>
                                                        <template v-if="info.type == '27'">
                                                            <span className="back">{{newsTxtAdjust ? "不红不返" : "不中不返"}}</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item.need_back != '0'">
                                                                <span className="back">{{newsTxtAdjust ? "不红返还" : "不中返还"}}</span>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                        <div className="recommend-match-info">
                                            <template v-if="item.type == '11' || item.type == '12' || item.type == '6'">
                                                <span class="game2">篮球</span>
                                            </template>
                                            <template v-else-if="item.type == '27'">
                                                <span class="game1">电竞</span>
                                            </template>
                                            <template>
                                                <span class="game1">足球</span>
                                            </template>
                                        <span class="idate">{{item.happened}}</span>
                                            <template v-if="item.sales * 1 > 0">
                                                <div class="read">{{item.sales}}{{newsTxtAdjust ? '解锁':'购买'}} {{item.browsenum}}阅读</div>
                                            </template>
                                            <template v-else>
                                                <div class="read">{{item.browsenum}}阅读</div>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { isHiscores, appChangeName, changeUserImgUrl, isBaiduBox, getCookie, isAndroid, formatNum, isJHAppios, getAppV, isJHAppAn, getsrc, isJHApp } from "../../utils/base"
import { checkInfotime, getInfoNews, getRecommendThird } from "../../api/modelTemporary"
import payinfo from "../../components/programme/payinfo.vue"
import mutil from "../../utils/mutil"
import Userlist from "../../components/programme/Userlist.vue"
import Maintext from "../../components/programme/Maintext.vue"
import Card from "../../components/programme/Card.vue"
import Reward from "../../components/programme/Reward.vue"
import Like from "../../components/programme/Like.vue"
export default {
    name: "contentProg",
    components: {
        payinfo,
        Userlist,
        Maintext,
        Card,
        Reward,
        Like
    },
    data () {
        changeUserImgUrl()
        return {
            zqMatchStateMap: {
                "-1": "已完赛",
                "-11": "待定",
                "-12": "腰斩",
                "-13": "中断",
                "-14": "推迟",
                "-10": "取消",
                "-99": "异常"
            },
            lqMatchStateMap: {
                "-1": "已完赛",
                "-2": "待定",
                "-3": "中断",
                "-4": "取消",
                "-5": "推迟",
                "-99": "异常"
            },
            djMatchStateMap: {
                0: "未开赛",
                1: "已开赛",
                "-1": "已完赛",
                "-20": "取消",
                "-10": "放弃",
                "-99": "删除"
            },
            authorlevelurl: "https://s.jihaimall.com/h5/image/userlebal/authorlevel",
            anchorurl: "https://s.jihaimall.com/h5/image/userlebal/anchorlogo.png",
            wrapclass: false,
            newNameJhty: 0,
            identity_split: "专家",
            info: null,
            is_followed: false, // 判断是否已关注
            show_follow: false,
            is_followed_match: 0, // 是否关注赛事
            matchCountDown: null,
            bkb_away: 0, // 主队换位
            is_own: false, // 判断是否自己文章
            // 如果有比赛
            matchTime: '',
            matchVs: '',
            newsTxtAdjust: 0
        }
    },
    created () {
        this.initData()
        this.getUserInfo()
    },
    mounted () {
    },
    updated () {
        this.getTime()
    },
    methods: {
        // 篮球
        // tabsLan (item,type) {

        // },
        setInfoOder (info) {
            // 竞彩篮球比分卡片换位
            var infoOrder = [];
            infoOrder = info
            if (this.bkb_away === 1 && (info.type === '11' || info.type === '12' || info.type === '6' || info.type === '27')) {
                if (infoOrder && infoOrder.length > 1) {
                    var tmpOrder = "";
                    if (infoOrder[0].is_bet === 1) {
                        tmpOrder = infoOrder[0];
                        infoOrder[0] = infoOrder[1];
                        infoOrder[1] = tmpOrder;
                    }
                }
            }
            infoOrder.forEach((item) => {
                var oddsFlag = false
                var matchOpts = "平"
                let matchSps = item.betOdds
                let matchShowOdds = item.odds > 0 ? "+" + item.odds : item.odds
                if (this.info.type === '11') {
                    const handicap = formatNum(item.odds, 1)
                    switch (item.betCode) {
                    case "1":
                        matchOpts = "小于" + handicap;
                        break;
                    case "2":
                        matchOpts = "大于" + handicap;
                        break;
                    case "3":
                        oddsFlag = item.odds !== "0";
                        matchOpts = item.odds === "0" ? "主胜" : "让主胜";
                        matchSps = "胜 " + item.betOdds;
                        break;
                    case "0":
                        oddsFlag = item.odds !== "0";
                        matchOpts = item.odds === "0" ? "客胜" : "让客胜";
                        matchSps = "胜 " + item.betOdds;
                        matchShowOdds = matchShowOdds > 0 ? matchShowOdds * -1 : '+' + (matchShowOdds * -1);
                        break;
                    }
                } else {
                    if (item.betCode === "3") {
                        matchOpts = this.info.match_info.homeNameJ;
                        matchSps = "胜 " + item.betOdds;
                    } else if (item.betCode === "0") {
                        matchOpts = this.info.match_info.awayNameJ;
                        matchSps = "胜 " + item.betOdds;
                    }
                }
                item.oddsFlag = oddsFlag
                item.matchOpts = matchOpts
                item.matchSps = matchSps
                item.matchShowOdds = matchShowOdds
            })
            // let oddsFlag = false
            return infoOrder
        },
        isJHApps () {
            return isJHApp()
        },
        getsrcs () {
            return getsrc()
        },
        isJHAppAns () {
            return isJHAppAn()
        },
        getAppVs () {
            return getAppV()
        },
        isJHAppioss () {
            return isJHAppios()
        },
        isAndroids () {
            return isAndroid()
        },
        ifMatchInfo (info) {
            // VS
            this.matchTime = info.match_info.matchTime
            this.matchVs = 'vs'
            if (info.match_info && info.matchid * 1) {
                if (info.matchState * 1 < 0) {
                    if (info.matchState * 1 === -1) {
                        // 篮球推荐比分换位
                        if (this.bkb_away === 1 && (info.type === '11' || info.type === '12' || info.type === '6')) {
                            this.matchVs = info.awayWholeGoals + ":" + info.homeWholeGoals;
                        } else {
                            if (info.type === '27') {
                                this.matchVs = "完赛";
                            } else {
                                this.matchVs = info.homeWholeGoals + ":" + info.awayWholeGoals;
                            }
                        }
                    } else {
                        if (info.type === '27') {
                            if (info.matchState * 1 === -20) {
                                this.matchVs = "赛事取消";
                            } else if (info.matchState * 1 === -10) {
                                this.matchVs = "赛事放弃";
                            } else if (info.matchState * 1 === -99) {
                                this.matchVs = "赛事删除";
                            }
                        }
                    }
                } else if (info.matchState * 1 > 0) {
                    // 篮球
                    if (info.type === '11' || info.type === '12' || info.type === '6') {
                        // 上、下半场
                        if (info.match_info.eventType === '2') {
                            if (info.matchState === '1') {
                                this.matchTime = "上半场";
                            } else {
                                this.matchTime = "下半场";
                            }
                        } else {
                            this.matchTime = mutil.LqMatchStateMap[info.matchState];
                        }
                    } else if (info.type === '27') {
                        this.matchTime = info.match_info.matchTime;
                    } else {
                        this.matchTime = mutil.matchStateMap[info.matchState]
                    }
                    if (this.bkb_away === 1 && (info.type === '11' || info.type === '12' || info.type === '6')) {
                        this.matchVs = info.awayWholeGoals + ":" + info.homeWholeGoals;
                    } else {
                        if (info.type === '27') {
                            this.matchVs = "已开赛";
                        } else {
                            this.matchVs = info.homeWholeGoals + ":" + info.awayWholeGoals;
                        }
                    }
                }
            }
        },
        // 判断主客队图片
        matchLogo (info, type) {
            if (info.type === '11' || info.type === '12' || info.type === '6') {
                return type === 'home' ? info.match_info.homeTeamIcon || "https://s.jihaimall.com/h5/image/home2.png" : info.match_info.awayTeamIcon || "https://s.jihaimall.com/h5/image/guest2.png"
            } else {
                return type === 'home' ? info.match_info.homeTeamIcon || "https://s.jihaimall.com/h5/image/home_new.png" : info.match_info.awayTeamIcon || "https://s.jihaimall.com/h5/image/guest_new.png"
            }
        },
        getTimeCountdown (time) {
            var self = this;
            var countdown = document.getElementById("match_countdown");
            if (countdown) {
                clearTimeout(this.matchCountDown);
                if (time > 0) {
                    var hh = Math.floor(time / 3600);
                    var mm = Math.floor((time - 3600 * hh) / 60);
                    var ss = time - 3600 * hh - 60 * mm;
                    countdown.style.display = "inline";
                    document.getElementById("countdown_hh").innerHTML = (hh < 10 ? "0" + hh : hh);
                    document.getElementById("countdown_mm").innerHTML = (mm < 10 ? "0" + mm : mm);
                    document.getElementById("countdown_ss").innerHTML = (ss < 10 ? "0" + ss : ss);
                    this.matchCountDown = setTimeout(function () {
                        self.getTimeCountdown(time - 1);
                    }, 1000);
                } else {
                    countdown.style.display = "none";
                }
            }
        },
        getTime () {
            if (this.info.match_info && this.info.match_info.diffMatchTime * 1 > 0) {
                this.getTimeCountdown(this.info.match_info.diffMatchTime * 1);
            } else {
                clearTimeout(this.matchCountDown);
                var countdown = document.getElementById("match_countdown");
                if (countdown) {
                    countdown.style.display = "none";
                }
            }
            if (this.info.match_info && this.info.match_info.isWin) {
                var matchHit = document.getElementById("match_hit");
                if (matchHit) {
                    matchHit.style.display = 'block';
                }
            }
        },
        hitStyle (info) {
            if (info.type === '11' || info.type === '12' || info.type === '6' || info.type === '27') {
                return "hit2";
            } else {
                return "hit1";
            }
        },
        isBaiduBoxs () {
            return isBaiduBox()
        },
        changeUserImgUrls (img) {
            return changeUserImgUrl(img)
        },
        async getUserInfo () {
            const params = {
                board: 'news',
                id: '2021111200000000517'
            }
            const res = await checkInfotime(params)
            const restwo = await getInfoNews({ id: '2021111200000000517' })
            if (res.errno === 0 && restwo.errno === 0) {
                const parmsSan = {
                    id: '2021111200000000517',
                    type: res.data.type,
                    matchid: res.data.matchid,
                    authorid: res.data.authorid,
                    'per-page': 2
                }
                const resSan = await getRecommendThird(parmsSan)
                this.info = Object.assign(restwo.data, res.data)
                this.info.myinfolist = resSan.data.other
                this.info.matchnews = resSan.data.match
                this.info.matchhot = resSan.data.hot
                this.ifMatchInfo(this.info)
            }
        },
        initData () {
            this.bkb_away = getCookie("bkb_away")
            if (appChangeName()) {
                this.newNameJhty = 1
            }
            if (isHiscores()) {
                this.wrapclass = "hiscores";
            } else if (this.newNameJhty) {
                this.wrapclass = "jhty";
            } else {
                this.wrapclass = "article";
            }
        }
    }
}
</script>
